var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/users"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M23 16.24c-.98-2.308-2.75-3.495-5.308-3.56l-2.063 1.332-2.041-1.317c-.43.011-2.321.341-2.321.341m-.475-6.408.222-.665C11.486 4.009 12.591 2 15.678 2c3.087 0 4.11 2.015 4.664 3.963.432 1.435.753 2.419.961 2.95.102.26-.063.54-.368.627-.014.004-1.312.595-3.146.905-.612.39-1.34.617-2.122.617a3.935 3.935 0 0 1-2.065-.58 12.216 12.216 0 0 1-1.12-.223M15.667 21c-1.056-3.194-3.513-4.78-7.371-4.76C4.438 16.261 2.006 17.848 1 21M8.407 6.272c2.227 0 4.033 1.753 4.033 3.916 0 2.163-1.806 3.916-4.033 3.916-2.228 0-4.034-1.753-4.034-3.916 0-2.163 1.806-3.916 4.034-3.916Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.344d799b2e28addf3c766d367d75c66f.svg";
export { ForwardRef as ReactComponent };